var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NavLogin } from '../';
import ButtonUser from './ButtonUser';
import DropdownUser from './DropdownUser';

import './NavUser.scss';

var NavUser = (_temp2 = _class = function (_Component) {
    _inherits(NavUser, _Component);

    function NavUser() {
        var _temp, _this, _ret;

        _classCallCheck(this, NavUser);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onToggle = function () {
            if (_this.props.onToggle) {
                _this.props.onToggle();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    NavUser.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            user = _props.user,
            expanded = _props.expanded;


        if (!user) {
            return React.createElement(NavLogin, this.props);
        }

        return React.createElement(
            'div',
            { className: 'nav-user' },
            React.createElement(ButtonUser, _extends({}, this.props, { expanded: expanded, controls: id, onClick: this.onToggle })),
            React.createElement(DropdownUser, _extends({}, this.props, { expanded: expanded, id: id }))
        );
    };

    return NavUser;
}(Component), _class.defaultProps = {
    id: "nav-user",
    user: {
        initials: "NN"
    },
    expanded: false,
    loginUrl: "/login",
    logoutUrl: "/logout"
}, _temp2);
NavUser.propTypes = process.env.NODE_ENV !== "production" ? {
    /** User info */
    user: PropTypes.shape({
        uniqueId: PropTypes.string,
        imageUrl: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string,
        initials: PropTypes.string
    }),
    expanded: PropTypes.bool,
    loginUrl: PropTypes.string,
    logoutUrl: PropTypes.string,
    /** App info */
    app: PropTypes.shape({
        version: PropTypes.string,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string
    }),
    onToggle: PropTypes.func
} : {};


export default NavUser;